var template = {};

template.genericModal = `
  <div class="modal fade show" style="display: block;" role="dialog">
    <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
      <div class="modal-content rounded-6 shadow">
        <div class="modal-header border-bottom-0">
          <h5 class="modal-title">{{{header}}}</h5>
          <button
            type="button"
            class="btn-close"
            data-action="cancel"></button>
        </div>
        <div class="modal-body py-0">{{{body}}}</div>
        <div class="modal-footer flex-row border-top-0">{{{footer}}}</div>
      </div>
    </div>
  </div>
  <div class="modal-backdrop fade show"></div>
`;

template.confirmModal = Handlebars.compile(template.genericModal)({
  header: `{{title}}`,
  body: `{{message}}`,
  footer: `
    <button
      type="button"
      data-action="done"
      class="btn rounded-pill btn-primary me-2 flex-grow-1">
      OK
    </button>
    <button
      type="button"
      data-action="cancel"
      class="btn rounded-pill btn-light text-secondary flex-grow-1">
      Cancel
    </button>
  `
});

template.customizedConfirmModal = Handlebars.compile(template.genericModal)({
  header: `{{title}}`,
  body: `{{{rawHtml}}}`,
  footer: `
    <button
      type="button"
      data-action="done"
      class="btn rounded-pill btn-primary me-2 flex-grow-1">
      Yes
    </button>
    <button
      type="button"
      data-action="cancel"
      class="btn rounded-pill btn-light text-secondary flex-grow-1">
      Cancel
    </button>
  `
});

template.alertModal = Handlebars.compile(template.genericModal)({
  header: `<i class="bi bi-exclamation-triangle"></i> {{title}}`,
  body: `{{message}}`,
  footer: `
    <button
      type="button"
      data-action="done"
      class="btn rounded-pill btn-primary flex-grow-1">
      OK
    </button>
  `
});

template.promptModal = Handlebars.compile(template.genericModal)({
  header: `{{title}}`,
  body: `
    <div class="form-floating">
      <input
        type="text"
        class="form-control"
        data-field="value"
        placeholder="{{placeholder}}"
        value="{{value}}">
      <label>{{message}}</label>
    </div>
  `,
  footer: `
    <button
      type="button"
      data-action="done"
      class="btn rounded-pill btn-primary me-2 flex-grow-1">
      OK
    </button>
    <button
      type="button"
      data-action="cancel"
      class="btn rounded-pill btn-light text-secondary flex-grow-1">
      Cancel
    </button>
  `
});

template.shareModal = Handlebars.compile(template.genericModal)({
  header: `{{title}}`,
  body: `
    <div class="d-flex align-items-center">
      <div class="form-floating flex-grow-1 me-2">
        <input
          class="form-control"
          value="{{copyText}}"
          readonly>
        <label>{{message}}</label>
      </div>
      <button
        class="btn btn-outline-primary icon-button-copy"
        data-clipboard-text="{{copyText}}"
        data-toggle="tooltip"
        data-tooltip-direction="top"
        title="Copy">
        <i class="bi bi-clipboard"></i>
      </button>
    </div>
  `,
  footer: `
    <button
      type="button"
      data-action="done"
      class="btn rounded-pill btn-primary flex-grow-1">
      Done
    </button>
  `
});
